module.exports = __webpack_public_path__ + "img/support.168bfc34.svg";